import { useEffect } from "react";

const ensureTag = (selector, createTag) => {
  let el = document.querySelector(selector);
  if (!el) {
    el = createTag();
    document.head.appendChild(el);
  }
  return el;
};

const setCanonical = (href) => {
  const canonical = ensureTag("link[rel='canonical']", () => {
    const tag = document.createElement("link");
    tag.setAttribute("rel", "canonical");
    return tag;
  });
  canonical.setAttribute("href", href);
};

const setMeta = (name, content, isProperty = false) => {
  const selector = isProperty
    ? `meta[property='${name}']`
    : `meta[name='${name}']`;

  const meta = ensureTag(selector, () => {
    const tag = document.createElement("meta");
    if (isProperty) {
      tag.setAttribute("property", name);
    } else {
      tag.setAttribute("name", name);
    }
    return tag;
  });

  meta.setAttribute("content", content);
};

const PageSeo = ({ title, description }) => {
  useEffect(() => {
    const siteTitle = "Thakkhar Realtors";
    const resolvedTitle = title ? `${title} | ${siteTitle}` : siteTitle;
    document.title = resolvedTitle;

    const resolvedDescription =
      description ||
      "Thakkhar Realtors offers verified properties, transparent pricing, and professional real estate guidance in Panvel and Navi Mumbai.";

    const url = window.location.href;
    setMeta("description", resolvedDescription);
    setMeta("og:title", resolvedTitle, true);
    setMeta("og:description", resolvedDescription, true);
    setMeta("og:url", url, true);
    setMeta("og:type", "website", true);
    setCanonical(url);
  }, [title, description]);

  return null;
};

export default PageSeo;
